import React from 'react';
import {Accordion} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from './accordions.module.scss';

type Props = {
  categories: ICategory[]
};

const Accordions: React.FC<Props> = ({ categories }) => {
  return (
      <Accordion>
        {categories.map((category, index) => (
            <React.Fragment key={index}>
                {category.children && category.children.length ? (
                    <Accordion.Item eventKey={index+''}>
                        <Accordion.Header><Link to={"/posts/" + category.slug}>{category.category}</Link></Accordion.Header>
                        <Accordion.Body>
                            <Accordions categories={category.children || []} />
                        </Accordion.Body>
                    </Accordion.Item>
                ) : (
                    <div><Link to={"/posts/" + category.slug}>{category.category}</Link></div>
                )}
            </React.Fragment>
        ))}
      </Accordion>
  );
}

export default Accordions;
